<template>
  <div class="promotion-page">
    <div class="promotion-toolbar">
      <b-form-datepicker
        size="sm"
        :date-disabled-fn="dateDisabled"
        @context="onDatePicked"
        v-model="selectedEndDate"
        today-button
        close-button
        locale="zh"
      ></b-form-datepicker>
    </div>

    <div v-if="loading" class="text-center text-muted py-3">加载中...</div>
    <div v-else class="promotion-grid-wrap">
      <div class="promotion-header" :style="gridStyle">
        <div class="promotion-cell promotion-label"></div>
        <div v-for="day in days" :key="'head-' + day" class="promotion-cell promotion-date">{{ formatDate(day) }}</div>
      </div>
      <div v-for="ban in bans" :key="'ban-' + ban" class="promotion-row" :style="gridStyle">
        <div class="promotion-cell promotion-label">{{ ban }}连板</div>
        <div v-for="day in days" :key="day + '-' + ban" class="promotion-cell">
          <div v-for="stock in getStocks(day, ban)" :key="day + '-' + ban + '-' + stock.stock_code" class="promotion-stock">
            <span class="promotion-name">{{ stock.stock_name }}</span>
            <span class="promotion-pct" :style="getPctStyle(stock.next_close_pct)">{{ formatPct(stock.next_close_pct) }}</span>
          </div>
        </div>
      </div>
      <div v-if="days.length===0" class="text-center text-muted py-3">暂无数据</div>
    </div>
  </div>
</template>

<script>
import { request_zzquant, request_zrx } from 'network/request'

export default {
  data() {
    const now = new Date()
    const today = now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate()
    return {
      selectedEndDate: today,
      all_trading_days: [],
      days: [],
      dayn: 10,
      dayDataMap: {},
      maxBan: 2,
      loading: false
    }
  },
  computed: {
    gridStyle() {
      const count = Math.max(this.days.length, 1)
      return { gridTemplateColumns: '70px repeat(' + count + ', minmax(120px, 1fr))' }
    },
    bans() {
      const max = Math.max(this.maxBan, 2)
      const arr = []
      for (let i = max; i >= 2; i--) arr.push(i)
      return arr
    }
  },
  watch: {
    selectedEndDate() {
      this.buildDays()
      this.fetchData()
    }
  },
  mounted() {
    request_zrx({ url: '/open/tradedays' }).then(res => {
      const days = res && res.data && res.data.data ? res.data.data : []
      this.all_trading_days = days
      if (days && days.length) {
        this.selectedEndDate = days[days.length - 1]
        this.buildDays()
        this.fetchData()
      }
    })
  },
  methods: {
    onDatePicked(ctx) {
      this.selectedEndDate = ctx.selectedYMD
    },
    dateDisabled(ymd, date) {
      const weekday = date.getDay()
      const time = date.getTime()
      const now = new Date().getTime()
      if (weekday === 0 || weekday === 6) return true
      if (time >= now) return true
      return false
    },
    buildDays() {
      const days = this.all_trading_days || []
      if (!days.length) return
      const idx = days.indexOf(this.selectedEndDate)
      const endIdx = idx >= 0 ? idx : days.length - 1
      const startIdx = Math.max(0, endIdx - (this.dayn - 1))
      this.days = days.slice(startIdx, endIdx + 1)
    },
    fetchData() {
      if (!this.days.length) return
      this.loading = true
      const requests = this.days.map(day => request_zzquant({ url: 'v3/open/review/uplimit/hot?date1=' + day }))
      Promise.all(requests).then(results => {
        const map = {}
        let maxBan = 2
        results.forEach((res, idx) => {
          const day = this.days[idx]
          const data = res && res.data && res.data.data ? res.data.data : {}
          const info = this.buildDayInfo(data)
          map[day] = info
          if (info.maxBan > maxBan) maxBan = info.maxBan
        })
        this.dayDataMap = map
        this.maxBan = maxBan
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    buildDayInfo(data) {
      const plates = data.plate || []
      const plateStocks = data.plate_stocks || {}
      const mapByBan = {}
      plates.forEach(item => {
        const plateCode = item[1]
        const list = plateStocks[plateCode] || []
        list.forEach(stock => {
          const ban = Number(stock.up_limit_keep_times)
          if (isNaN(ban) || ban < 2) return
          const code = stock.stock_code || ''
          if (!code) return
          if (!mapByBan[ban]) mapByBan[ban] = {}
          if (!mapByBan[ban][code]) {
            mapByBan[ban][code] = {
              stock_name: stock.stock_name || stock.stock_code,
              stock_code: code,
              next_close_pct: stock.next_close_pct,
              up_limit_keep_times: stock.up_limit_keep_times
            }
          }
        })
      })
      const stocksByBan = {}
      let maxBan = 2
      Object.keys(mapByBan).forEach(banStr => {
        const ban = Number(banStr)
        const arr = Object.values(mapByBan[banStr])
        arr.sort((a, b) => Number(b.next_close_pct || 0) - Number(a.next_close_pct || 0))
        stocksByBan[ban] = arr
        if (ban > maxBan) maxBan = ban
      })
      return { stocksByBan, maxBan }
    },
    getStocks(day, ban) {
      const info = this.dayDataMap[day]
      if (!info) return []
      return info.stocksByBan[ban] || []
    },
    formatDate(day) {
      if (!day) return ''
      return day.slice(5)
    },
    formatPct(val) {
      if (val === undefined || val === null || val === '') return '--'
      const num = Number(val)
      if (isNaN(num)) return '--'
      const fixed = Math.abs(num) >= 10 ? num.toFixed(1) : num.toFixed(2)
      return fixed + '%'
    },
    getGradientColor(start_color, end_color, percent) {
      start_color = start_color.replace(/^\s*#|\s*$/g, '')
      end_color = end_color.replace(/^\s*#|\s*$/g, '')
      if (start_color.length == 3) {
        start_color = start_color.replace(/(.)/g, '$1$1')
      }
      if (end_color.length == 3) {
        end_color = end_color.replace(/(.)/g, '$1$1')
      }
      function parse(rgb, i) {
        return parseInt(rgb.substr(i, 2), 16)
      }
      let start_r = parse(start_color, 0),
        start_g = parse(start_color, 2),
        start_b = parse(start_color, 4)
      let end_r = parse(end_color, 0),
        end_g = parse(end_color, 2),
        end_b = parse(end_color, 4)
      let r = end_r - start_r
      let g = end_g - start_g
      let b = end_b - start_b
      r = ((r * percent) + start_r)
      g = ((g * percent) + start_g)
      b = ((b * percent) + start_b)
      function hex(x) {
        let h = x.toString(16).split('.')[0].toUpperCase()
        return (h.length == 1) ? '0' + h : h
      }
      return '#' + hex(r) + hex(g) + hex(b)
    },
    getPercentColorFont(pt) {
      const isDark = document.body.classList.contains('theme-dark')
      if (pt === undefined || pt === null || pt === '') {
        return isDark ? '#9ca3af' : '#6c757d'
      }
      pt = Number(pt)
      if (isNaN(pt) || pt === 0) {
        return isDark ? '#e5e5e5' : '#111111'
      }
      if (pt > 0) {
        pt = +pt / 10
        const start = isDark ? '#f87171' : '#FF99CC'
        return this.getGradientColor(start, '#FB1023', pt)
      }
      if (pt < -10) {
        pt = -10
      }
      pt = -pt / 10
      const start = isDark ? '#4ade80' : '#66FF55'
      return this.getGradientColor(start, '#278B22', pt)
    },
    getPctStyle(val) {
      return { color: this.getPercentColorFont(val) }
    }
  }
}
</script>

<style scoped>
.promotion-page{
  padding:8px;
}
.promotion-toolbar{
  display:flex;
  justify-content:center;
  align-items:center;
  margin-bottom:6px;
}
.promotion-grid-wrap{
  overflow-x:auto;
}
.promotion-header,
.promotion-row{
  display:grid;
}
.promotion-cell{
  border:1px solid var(--border-color);
  padding:4px;
  min-height:70px;
  background: var(--bg-card);
}
.promotion-label{
  background:#f3f4f6;
  color:#6b7280;
  font-weight:600;
  text-align:center;
  display:flex;
  align-items:center;
  justify-content:center;
}
.promotion-date{
  font-size:12px;
  text-align:center;
  color:#6b7280;
}
.promotion-stock{
  display:flex;
  justify-content:space-between;
  align-items:center;
  gap:4px;
  font-size:11px;
  line-height:1.2;
}
.promotion-name{
  color:#000000;
  font-size:12px;
  font-weight:600;
}
.promotion-pct{
  font-size:10px;
}
.theme-dark .promotion-label{
  background:#111827;
  color:#9ca3af;
}
.theme-dark .promotion-name{
  color:#e5e5e5;
}
</style>
